module.exports = __webpack_public_path__ + "static/media/file-fill.1eefb466.svg";